import { ParcelModel } from '@app/common/models/parcel.model';
import { ConstructionObjectModel } from '@app/common/models/construction-object.model';
import { OccupationTypeModel } from './occupation-type.model';

import { ExpertModel } from '@app/ps/models/expert.model';
import { OccupationSolutionTypeModel } from './occupation-solution-type.model';
import { User } from "@app/models/user";
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

export class OccupationModel {
  id: number;
  countCases: number;
  countCasesFuture: number;
  countCasesNotOwnersStatementLiability: number;
  parcel: ParcelModel;
  pardil: number;
  rentalPriceType: string;
  rentalExpert: ExpertModel;
  rentalExpertOpinionNumber: string;
  rentalExpertOpinionDate: string;
  rentalOtherPriceSource: string;
  priceAssessmentLandPrice: number;
  priceAssessmentYear: number;
  rentalLength: number;
  rentalPriceUnit: string;
  totalRentPrice: number;
  yearRentPrice: number;
  zabcis: number;
  zabciskn: string;
  zabcisknp: string;
  zabidpar: number;
  zabku: number;
  zabkutx: string;
  zablv: number;
  zabsk12: number;
  zabst: number;
  zabsttx: string;
  zabtyp: number;
  zabtyptx: string;
  zabvym: number;
  constructionObjects?: ConstructionObjectModel[];
  occupationType: OccupationTypeModel;
  nabyvatel: string;
  icoNabyvatele: string;
  typNabyvatele: string;
  investor: string;
  endDate?: string;
  nextOccupationId?: number;

  caseOccupation?: any;
  caseParcel?: any;
  geometry?: string;
  solutionType?: string;
  priceAssessmentPrice: any;
  priorityIndex?: number;

  finalSolutionType?: OccupationSolutionTypeModel;
  finalSolutionState?: FinalSolutionStateEnum;
  finalSolutionNote?: string;
  finalSolutionReason?: string;
  finalSolutionDate?: string;
  finalSolutionApprover?: User;
  editMode?: string;
  finalSolutionOtherChange?: {
    changeGeometry?: boolean;
    changeWholeParcel?: boolean;
    changeOccupationType?: boolean;
    newOccupationType?: any;
    changeConstructionObjects?: boolean;
    newConstructionObjects?: any[];
    changeOccupationNumber?: boolean;
    newOccupationNumber?: string;
    newNabyvatel?: {
      id?: string;
      nabyvatel: string;
      typNabyvatele?: string;
      icoNabyvatele?: string;
      acquirerId?: number;
    };
  };
}
